import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

const SEO = ({ businessName, pageName, description, images }) => {
  const seo = {
    title: `${pageName} | ${businessName}`,
    description,
    image: images && images.length ? images[0] : null,
  };

  return (
    <Helmet title={seo.title}>
      {seo.description && <meta name="description" content={seo.description} />}
      {seo.image && <meta name="image" content={seo.image} />}
    </Helmet>
  );
};

export default SEO;

SEO.propTypes = {
  businessName: PropTypes.string.isRequired,
  pageName: PropTypes.string.isRequired,
  description: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.string),
};

SEO.defaultProps = {
  images: [],
};
